var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    "data-name": "Layer 10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.26 116.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #42c3ba;\n        stroke: #42c3ba;\n        stroke-miterlimit: 4;\n        stroke-width: 1px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Weather_Icons-09",
    "data-name": "Weather Icons-09",
    className: "cls-1",
    d: "M86.4,103.47c7.43-5.6,13.11-13.2,16.38-21.91.6-1.59-.21-3.36-1.8-3.96-.42-.16-.88-.22-1.33-.19-23.66,2-44.47-15.55-46.47-39.22-.54-6.43.37-12.9,2.66-18.93.6-1.59-.21-3.36-1.8-3.96-.42-.16-.88-.22-1.33-.19C25.63,17.36,5.48,41.13,7.72,68.22c2.24,27.09,26.01,47.24,53.1,45,9.28-.77,18.15-4.15,25.58-9.75ZM30.84,29.74c5.22-3.93,11.28-6.62,17.7-7.85-7.01,26.22,8.57,53.15,34.78,60.16,3.85,1.03,7.81,1.59,11.79,1.66-10.8,21.2-36.74,29.62-57.93,18.82-21.2-10.8-29.62-36.74-18.82-57.93,2.98-5.84,7.24-10.92,12.48-14.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.b4cb0efba5f8685f1cae32a97d00f965.svg";
export { ForwardRef as ReactComponent };